import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import child from './modules/child';
import {setPlugins} from './plugins';
import assess from './modules/assess';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: setPlugins(),
  modules: {
    global,
    child,
    assess
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js